<div class='big-wrapper'>
  <app-art-day-body filePath={{filePath}} yearStr={{year}} extStr={{ext}} myhtml={{myhtml}}></app-art-day-body>
  <app-collection-footer rawTitle={{title}} yearStr={{year}} publisher={{publisher}} fourth={{fourth}}></app-collection-footer>
</div>
